import React, { useEffect, useState } from 'react'
import SwalAlert from '../../../../../../../services/swalService/SwalService';
import ToastService from '../../../../../../../services/toastService/ToastService';
import CardSection from '../../../../../../../components/ui/card/CardSection';
import CenterModel from '../../../../../../../components/ui/centerModel/CenterModel';
import { getFileIcon } from '../../../../../../../lib/getFileIcon';
import { useDeleteSynergyAttachmentByIdMutation, useLazyGetSynergyAttachmentListBySynergyIdQuery } from '../../../../../../../app/services/projectSynergyAPI';
import IconButton from '../../../../../../../components/ui/iconbutton/IconButton';
import NoRecordFound from '../../../../../../../components/FinalMolGrid/ui/noRecordFound/NoRecordFound';
import AddsynergyAttachments from './AddsynergyAttachments';
import { useLazyGetDownloadFileQuery } from '../../../../../../../app/services/taskattachmentAPI';

const SynergyAttachments = (props) => {
  const synergyId = props.synergyId;
  
  const [isModelOpen, setisModelOpen] = useState(false);
  const [attachmentsData, setattachmentsData] = useState([]);
  const [downloadFileName, setDownloadFileName] = useState();

  const { confirm } = SwalAlert();

  const [
    getSynergyAttachmentListBySynergyId,
    {
      isFetching: isgetSynergyAttachmentListBySynergyIdFetching,
      isSuccess: isgetSynergyAttachmentListBySynergyIdFetched,
      data: getSynergyAttachmentListBySynergyIdData,
    },
  ] = useLazyGetSynergyAttachmentListBySynergyIdQuery();


  const [deleteSynergyAttachmentById, {
    isLoading: isdeleteSynergyAttachmentByIdDeleting,
    isSuccess: isdeleteSynergyAttachmentByIdDeleteSucess,
    data: isdeleteSynergyAttachmentByIdDeleteData
  },] = useDeleteSynergyAttachmentByIdMutation();

  const [getDownloadFile, {
    isLoading: isDownalodFetching,
    isSuccess: isDownalodSucess,
    data: isDownalodData,
  },] = useLazyGetDownloadFileQuery();

  useEffect(() => {
    if (synergyId) {
      getSynergyAttachmentListBySynergyId(synergyId);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [synergyId])

  useEffect(() => {
    if (!isgetSynergyAttachmentListBySynergyIdFetching &&
      isgetSynergyAttachmentListBySynergyIdFetched &&
      getSynergyAttachmentListBySynergyIdData) {
      setattachmentsData(getSynergyAttachmentListBySynergyIdData);
    }
  }, [isgetSynergyAttachmentListBySynergyIdFetching,
    isgetSynergyAttachmentListBySynergyIdFetched,
    getSynergyAttachmentListBySynergyIdData]);


  useEffect(() => {
    if (!isdeleteSynergyAttachmentByIdDeleting &&
      isdeleteSynergyAttachmentByIdDeleteSucess &&
      isdeleteSynergyAttachmentByIdDeleteData) {
      ToastService.success(isdeleteSynergyAttachmentByIdDeleteData.errorMessage);
    }
  }, [isdeleteSynergyAttachmentByIdDeleting,
    isdeleteSynergyAttachmentByIdDeleteSucess,
    isdeleteSynergyAttachmentByIdDeleteData]);

    useEffect(() => {
      if (!isDownalodFetching && isDownalodSucess && isDownalodData) {
        if (isDownalodData.blobUrl && isDownalodData.contentType) {
          const fileURL = isDownalodData.blobUrl;
          const link = document.createElement("a");
          link.href = fileURL;
          link.download = downloadFileName;
          document.body.appendChild(link);
          link.click();
          link.remove();
  
          URL.revokeObjectURL(fileURL);
        }
      }
    }, [isDownalodFetching, isDownalodSucess, isDownalodData, downloadFileName]);
  
    const handaldownload = (filename) => {
      getDownloadFile(filename);
      setDownloadFileName(filename);
    };
    
  const AddhandleToggleModal = () => {
    setisModelOpen(!isModelOpen);
  };

  const onClose = () => {
    setisModelOpen(false);
    getSynergyAttachmentListBySynergyId(synergyId);
  };

  const handleDelete = (attachmentID, index) => {
    confirm(
      "Delete?",
      "Are you sure you want to Delete?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deleteSynergyAttachmentById(attachmentID);
        setattachmentsData((prevFiles) =>
          prevFiles.filter((_, i) => i !== index)
        );
      }
    });
  };

  return (
    <div className="edit-synergy-attachment-section">
      <CardSection
        cardTitle="Attachments"
        icon="material-symbols:attachment-file"
        rightButton={true}
        buttonClassName="theme-btn"
        buttonText="Attachments"
        textWithIcon={true}
        iconName="material-symbols:add-rounded"
        fontIcon={true}
        titleButtonClick={AddhandleToggleModal}
      >
        <div className="synergy-attachments-section">
          <div className="row">
            {
              attachmentsData && attachmentsData.length > 0 ? (
                attachmentsData.map((file, index) => (

                  <div className="attachment-card">
                    <div className="synergy-attachments-item">
                      <div
                        className="d-flex align-items-center"
                        style={{ gap: "15px" }}
                      >
                        <div className="attachment-icon">
                          <img
                            src={getFileIcon(file.fileName)}
                            alt={file.fileName}
                            className="file-icon"
                          />
                        </div>
                        <div className="attachment-name">{file.fileName}</div>
                      </div>
                      <div className="attachment-action-btns">
                        <IconButton
                          variant="contained"
                          icon="heroicons-outline:download"
                          shape="circle"
                          className="icon-btn download-btn"
                          size={"small"}
                          color="success"
                          onClick={() => handaldownload(file.fileName)}
                        />
                        <IconButton
                          variant="contained"
                          icon="mingcute:delete-line"
                          shape="circle"
                          className="icon-btn download-btn"
                          size={"small"}
                          color="error"
                          onClick={() => handleDelete(file.attachmentID, index)}
                        />
                      </div>
                    </div>
                  </div>

                ))
              ) : (
                <div className="no-data-found">
                  <NoRecordFound message="No Attachment" />
                </div>)
            }
          </div>
        </div>
        <div>
          {isModelOpen && (
            <CenterModel
              showModal={isModelOpen}
              handleToggleModal={onClose}
              modalTitle={"Add Synergy Attachments"}
              modelSizeClass="w-40"
            >
              <AddsynergyAttachments
                onClose={onClose}
                synergyId={synergyId}
              />
            </CenterModel>
          )}
        </div>

      </CardSection>
    </div>
  )
}

export default SynergyAttachments;
